import { createSlice } from "@reduxjs/toolkit";

const myReviewSlice = createSlice({
  name: "myReview",
  initialState: {
    disabledField: true,
    updateFields: true,
  },
  reducers: {
    setDisabledFields(state, action) {
      state.disabledField = action.payload;
    },
    setUpdateFields(state, action) {
      state.updateFields = action.payload;
    },
  },
});

export const myReviewSliceActions = myReviewSlice.actions;

export default myReviewSlice.reducer;
